export const getText = (config, experimentGroup, regionId) => {
  const multiPostingPlatforms = config.get('addformConfig.multiPosting.platforms');
  const defaultText = config.get('addformConfig.multiPosting.text');

  if (!regionId || !multiPostingPlatforms[regionId]) {
    return defaultText;
  }

  const regionData = multiPostingPlatforms[regionId];
  const { descriptionAll, descriptionFree } = regionData;

  if (experimentGroup === 'B' && descriptionAll) {
    return descriptionAll;
  } else if (experimentGroup === 'C' && descriptionFree) {
    return descriptionFree;
  }

  return defaultText;
};
